import React, { useCallback, useEffect, useState } from "react";
import Scrollspy from "react-scrollspy";
import { useLocation, useNavigate } from "react-router-dom";
import { navItems } from "../../config/site";

const sectionIds = navItems.map((item) => item.id);

const Header = () => {
  const [click, setClick] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const closeMobileMenu = () => setClick(false);
  const toggleMobileMenu = () => setClick((prev) => !prev);

  const getHeaderOffset = useCallback(() => {
    const isMobile = window.matchMedia("(max-width: 1040px)").matches;
    const header = document.querySelector(
      isMobile
        ? ".shane_tm_mobile_menu > .topbar_inner"
        : ".shane_tm_topbar .topbar_inner"
    );

    return (header?.getBoundingClientRect().height || (isMobile ? 70 : 90)) + 24;
  }, []);

  const scrollToSection = useCallback((sectionId) => {
    const section = document.getElementById(sectionId);

    if (!section) {
      return false;
    }

    const target =
      sectionId === "home"
        ? section
        : section.querySelector(".container, .talk_inner") || section;
    const targetTop =
      sectionId === "home"
        ? 0
        : window.scrollY + target.getBoundingClientRect().top - getHeaderOffset();

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth",
    });

    return true;
  }, [getHeaderOffset]);

  const handleNavClick = (event, sectionId) => {
    event.preventDefault();
    closeMobileMenu();

    const destination = { pathname: "/", hash: `#${sectionId}` };

    if (!isHomePage) {
      navigate(destination);
      return;
    }

    if (location.hash !== destination.hash) {
      navigate(destination);
    }

    window.requestAnimationFrame(() => scrollToSection(sectionId));
  };

  useEffect(() => {
    const handleScroll = () => setNavbar(window.scrollY >= 80);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isHomePage) {
      return undefined;
    }

    const sectionId = decodeURIComponent(location.hash.replace("#", ""));

    if (!sectionIds.includes(sectionId)) {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => scrollToSection(sectionId));

    return () => window.cancelAnimationFrame(frameId);
  }, [isHomePage, location.hash, scrollToSection]);

  return (
    <>
      <div className="shane_tm_topbar">
        <div className={navbar ? "topbar_inner opened" : "topbar_inner"}>
          <div className="menu">
            <Scrollspy
              className="anchor_nav"
              items={sectionIds}
              currentClassName="current"
              offset={-200}
            >
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`/#${item.id}`}
                    onClick={(event) => handleNavClick(event, item.id)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </Scrollspy>
          </div>
          <div className="logo">
            <a href="/#home" onClick={(event) => handleNavClick(event, "home")}>
              <img src="/img/logo.jpg" alt="וידבסקי ושות׳" />
            </a>
          </div>
        </div>
      </div>

      <div className="shane_tm_mobile_menu">
        <div className="topbar_inner">
          <div className="container bigger">
            <div className="topbar_in">
              <div
                className="my_trigger"
                onClick={toggleMobileMenu}
                role="button"
                aria-label="תפריט"
                aria-expanded={click}
              >
                <div
                  className={
                    click
                      ? "hamburger hamburger--collapse-r is-active"
                      : "hamburger"
                  }
                >
                  <div className="hamburger-box">
                    <div className="hamburger-inner"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={click ? "dropdown active" : "dropdown"}>
          <div className="container">
            <span className="close_menu" onClick={closeMobileMenu}>
              סגור
            </span>
            <div className="dropdown_inner">
              <ul className="anchor_nav">
                {navItems.map((item, idx) => (
                  <li key={item.id} className={idx === 0 ? "current" : ""}>
                    <a
                      href={`/#${item.id}`}
                      onClick={(event) => handleNavClick(event, item.id)}
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
